import React from "react";
import { motion } from "framer-motion";

const BacklogSection = ({
  developers,
  backlogTasks,
  currentBacklogs,
  backlogDeveloper,
  backlogProject,
  backlogDescription,
  onDeveloperChange,
  onProjectChange,
  onDescriptionChange,
  onSubmit,
  currentPage,
  totalPages,
  setCurrentPage,
}) => {
  return (
    <motion.div
      className="bg-gray-800 p-6 rounded-2xl shadow-lg mb-8" 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h2 className="text-xl font-semibold mb-4 text-yellow-400">
        Assign Backlog Task
      </h2>

      <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Developer Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Select Developer
          </label>
          <select
            value={backlogDeveloper}
            onChange={onDeveloperChange}
            className="w-full px-3 py-2 bg-gray-700 rounded-md text-gray-100 focus:outline-none"
          >
            <option value="">-- Choose Developer --</option>
            {developers.map((dev) => (
              <option key={dev.id} value={dev.id}>
                {dev.username}
              </option>
            ))}
          </select>
        </div>

        {/* Project Name */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Project Name
          </label>
          <input
            type="text"
            value={backlogProject}
            onChange={onProjectChange}
            placeholder="Enter project name"
            className="w-full px-3 py-2 bg-gray-700 rounded-md text-gray-100 focus:outline-none"
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Task Description
          </label>
          <input
            type="text"
            value={backlogDescription}
            onChange={onDescriptionChange}
            placeholder="Enter task details"
            className="w-full px-3 py-2 bg-gray-700 rounded-md text-gray-100 focus:outline-none"
          />
        </div>

        {/* Submit */}
        <div className="md:col-span-3 text-right">
          <button
            type="submit"
            className="bg-yellow-600 hover:bg-yellow-700 px-6 py-2 rounded-lg font-semibold transition duration-300"
          >
            Assign Task
          </button>
        </div>
      </form>

      {/* Backlog Tasks Table */}
      {backlogTasks.length > 0 && (
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-3 text-yellow-400">
            Previously Assigned Backlog Tasks
          </h3>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-700">
              <thead>
                <tr className="bg-gray-700 text-gray-200">
                  <th className="py-2 px-4 border border-gray-600">Developer</th>
                  <th className="py-2 px-4 border border-gray-600">Project</th>
                  <th className="py-2 px-4 border border-gray-600">Description</th>
                  <th className="py-2 px-4 border border-gray-600">Status</th>
                </tr>
              </thead>
              <tbody>
                {currentBacklogs.map((task) => (
                  <tr key={task.id} className="text-gray-300 text-sm">
                    <td className="py-2 px-4 border border-gray-700">
                      {task.developer_name}
                    </td>
                    <td className="py-2 px-4 border border-gray-700">
                      {task.project_name}
                    </td>
                    <td className="py-2 px-4 border border-gray-700">
                      {task.description}
                    </td>
                    <td
                      className={`py-2 px-4 border border-gray-700 font-semibold ${
                        task.status === "Acknowledged"
                          ? "text-green-400"
                          : "text-yellow-400"
                      }`}
                    >
                      {task.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex justify-center items-center mt-4 space-x-2">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="px-3 py-1 bg-gray-700 rounded-md disabled:opacity-50"
                >
                  Prev
                </button>
                <span className="text-gray-300">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                  className="px-3 py-1 bg-gray-700 rounded-md disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default BacklogSection;
